import * as React from 'react';

import hoistNonReactStatic from 'hoist-non-react-statics';
import invariant from 'invariant';
import ReactDOM from 'react-dom';

import DOM from 'lib/DOM';
import KeyState from 'lib/KeyState';
import focusNode from 'utils/focusNode';
import getActiveElement from 'utils/getActiveElement';

function withLayerAutoFocus<Props extends {}>(
  Child: React.ComponentType<any>
): React.ComponentType<Props> {
  class LayerAutoFocus extends React.Component<any> {
    displayName = `withLayerAutoFocus(${(Child as unknown as React.SFC).displayName})`;

    UNSAFE_componentWillMount() {
      this._activeElement = getActiveElement();
    }

    componentDidMount() {
      // TODO: getTabbableElements() and focus the first tabbable element, so that things like
      // forms or buttons are automatically focused when opening dialogs

      // It's possible for the active element to change because of a `focusNode` call within the
      // rendered subtree. Check to see if the activeElement is within the modal.
      const node = ReactDOM.findDOMNode(this._child) as HTMLElement;
      invariant(
        node instanceof HTMLElement,
        'withLayerAutoFocus findDOMNode returned non HTMLElement'
      );
      const activeElement = getActiveElement();
      if (node && !node.contains(activeElement)) {
        if (DOM.getOffset(node).top < 0) {
          return;
        }
        focusNode(node);
      }
    }

    componentWillUnmount() {
      if (KeyState.isKeyDown()) {
        focusNode(this._activeElement);
      }
    }

    _activeElement: any;
    _child: any;

    render() {
      return (
        <Child
          {...this.props}
          ref={(r: React.Component) => {
            this._child = r;
          }}
        />
      );
    }
  }

  return hoistNonReactStatic(LayerAutoFocus, Child);
}

export default withLayerAutoFocus;
